import { fetchQuery, graphql } from "relay-runtime"
import { insureeDataFromSasisByNameAndDateOfBirthQuery } from "@/modules/admin/sasis-lookup/services/__generated__/insureeDataFromSasisByNameAndDateOfBirthQuery.graphql"
import { InsureeDataFromSasis } from "@/modules/admin/sasis-lookup/services/insureeDataFromSasisByHealthInsuranceCardNumberQuery"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query insureeDataFromSasisByNameAndDateOfBirthQuery($firstName: String!, $lastName: String!, $dateOfBirth: Date!) {
    ch_insureeDataFromSasisByNameAndDateOfBirth(firstName: $firstName, lastName: $lastName, dateOfBirth: $dateOfBirth) {
      mapped {
        firstName
        lastName
        dateOfBirth
        gender
        insureeNumber
        insuranceCardNumber
        socialSecurityNumber
        healthInsurance
        nationalInsuranceNumber
        isPrimary
        gatekeeperZsr
        validFrom
        validTo
        address {
          houseNumberStreet
          city
          postalCode
          countryCode
        }
      }
      rawXml
      returnCode
      returnMessage
    }
  }
`

export const fetchInsureeDataFromSasisByNameAndDateOfBirth = (
  firstName: string,
  lastName: string,
  dateOfBirth: string,
): Promise<InsureeDataFromSasis | null> =>
  fetchQuery<insureeDataFromSasisByNameAndDateOfBirthQuery>(
    RelayEnvironment,
    query,
    { firstName, lastName, dateOfBirth },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => response?.ch_insureeDataFromSasisByNameAndDateOfBirth ?? null)
